import moment from 'moment';
import { upperCase } from 'lodash';
import { setSelected } from '../../utils/filter/selection';
import { timePeriods, raceTypes } from '../../utils/filter';

const last3MonthOption = {
    label: 'Last 3 months',
    value: 'lastThree',
};

const getRaceTypesOptions = ({ FLAT, JUMPS }) => {
    const result = [];
    const { flat, jumps } = raceTypes.horse;
    if (FLAT) {
        result.push(...flat);
    }
    if (JUMPS) {
        result.push(...jumps);
    }
    return result;
};

export const timePeriodsFactory = (raceType, seasonsAvailable) => {
    const flatOrJumps = raceType.split('/')[1];
    const options = timePeriods.getAvailable(seasonsAvailable, upperCase(flatOrJumps));
    options[0].selected = true;

    const timePeriod = {
        title: 'time period',
        options,
        createdBy: {
            flatOrJumps,
            seasonsAvailable,
        },
    };
    return timePeriod;
};

const raceTypeFactory = (raceType, seasonsAvailable) => ({
    title: 'race type',
    options: setSelected(getRaceTypesOptions(seasonsAvailable), raceType),
});

const getMonthOptions = () => [
    {
        label: 'No filter',
        value: '',
    },
    ...moment.months().map((m, i) => ({
        label: m,
        value: `${i + 1}`,
    })),
];

export const monthFactory = (raceType, timePeriod, seasonsAvailable) => {
    const flatOrJumps = raceType.split('/')[1] || raceType;
    const typeSeasons = seasonsAvailable[upperCase(flatOrJumps)] || [];
    const selectedSeasonEndYear = timePeriod.substr(5);
    const selectedSeason = typeSeasons.find(
        ({ seasonEndDate }) => seasonEndDate.substr(0, 4) === selectedSeasonEndYear
    ) || {};
    const isCurrentSeason = moment(selectedSeason.seasonEndDate) > moment();

    const options = isCurrentSeason ? [last3MonthOption, ...getMonthOptions()] : getMonthOptions();
    options[0].selected = true;

    return {
        title: 'month',
        options,
        createdBy: {
            timePeriod,
            flatOrJumps,
            seasonsAvailable,
        },
    };
};

const categoriesFactory = (seasonsAvailable, { raceType, timePeriod }) => ({
    raceType: raceTypeFactory(raceType, seasonsAvailable),
    timePeriod: timePeriodsFactory(raceType, seasonsAvailable),
    month: monthFactory(raceType, timePeriod, seasonsAvailable),
});

export default categoriesFactory;



// WEBPACK FOOTER //
// ./src/js/horse/progenyResults/categories.js